<template>
  <transition name="modal">
    <div v-if="show" class="modal-mask">
      <div class="modal-container">
        <CloseButton />
        <Survey />
      </div>
    </div>
  </transition>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

import CloseButton from './CloseButton'
import Survey from './Survey'

const { mapActions } = createNamespacedHelpers('survey')

export default {
  name: 'SurveyModal',
  components: {
    Survey,
    CloseButton,
  },
  props: {
    show: Boolean,
  },
  methods: {
    ...mapActions(['closeSurvey']),
  },
}
</script>

<style scoped lang="postcss">
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.5s;
}

.modal-enter,
.modal-leave-to {
  opacity: 0;
}

.modal-mask {
  position: fixed;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
}

.modal-container {
  position: relative;
  background-color: white;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  width: 100%;
}

@media (max-width: 768px) {
  .modal-container {
    max-width: 520px;
    padding: 20px;
  }
}

@media (min-width: 769px) {
  .modal-container {
    max-width: 800px;
    padding: 60px 100px;
  }
}
</style>
